import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject, ListServerPaginationStateModel } from '../../../../../common';
import {
  ShipmentWaybillMaterialListSearchCriteria,
  ShipmentWaybillMaterialModel,
} from '../../models/shipment-waybill-materials.model';
import { ShipmentWaybillEndpoint } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillMaterialsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillMaterials(
    searchCriteria: ShipmentWaybillMaterialListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<ShipmentWaybillMaterialModel>> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Materials
    }?${getQueryStringFromObject({
      ...searchCriteria.waybillIdView,
      page: searchCriteria.page,
      size: searchCriteria.size,
    })}`;

    return this.http.withLoading().get<ListServerPaginationStateModel<ShipmentWaybillMaterialModel>>(url);
  }
}
